// (c) chaehongee. Confidential and proprietary.

export const AI_MODEL_DRAG_TYPES = [
    'application/x-knoll-ai-model',
    'text/x-knoll-ai-model',
] as const

const AI_MODEL_DRAG_MARKER = 'true'
const AI_MODEL_DRAG_FLAG = '__knollAiModelDragging'

export function setAiModelDragData(
    dataTransfer: DataTransfer,
    imageUrl: string
): void {
    for (const type of AI_MODEL_DRAG_TYPES) {
        dataTransfer.setData(type, AI_MODEL_DRAG_MARKER)
    }
    dataTransfer.setData('text/uri-list', imageUrl)
    dataTransfer.setData('text/plain', imageUrl)
}

export function setAiModelDragging(isDragging: boolean): void {
    if (typeof window === 'undefined') return
    if (isDragging) {
        ;(window as typeof window & Record<string, boolean>)[AI_MODEL_DRAG_FLAG] =
            true
    } else {
        delete (window as typeof window & Record<string, boolean>)[AI_MODEL_DRAG_FLAG]
    }
}

export function isAiModelDragging(): boolean {
    if (typeof window === 'undefined') return false
    return Boolean(
        (window as typeof window & Record<string, boolean>)[AI_MODEL_DRAG_FLAG]
    )
}

export function isAiModelDrag(dataTransfer: DataTransfer | null): boolean {
    if (!dataTransfer) return false
    const types = new Set(Array.from(dataTransfer.types || []))
    if (AI_MODEL_DRAG_TYPES.some((type) => types.has(type))) {
        return true
    }
    for (const type of AI_MODEL_DRAG_TYPES) {
        try {
            if (dataTransfer.getData(type) === AI_MODEL_DRAG_MARKER) {
                return true
            }
        } catch {
            // Ignore data access issues
        }
    }
    return isAiModelDragging()
}
